import { destroy } from 'infras/rest_client';
import { ViewerItem, UserListItem } from 'presentations/api/schema/user';
import { ProjectUserDeleteBody } from 'presentations/api/schema/project_user';
import { apiPath } from 'presentations/routes/path';
import { useState } from 'react';

interface Props {
  viewer: ViewerItem;
  projectUid: string;
  users: UserListItem[];
  onDeleted: (users: UserListItem[]) => void;
}

export function useMemberListDialog(props: Props) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [deleteUid, setDeleteUid] = useState<string | null>(null);

  const onClose = () => {
    setIsOpen(false);
  };

  const onDelete = async () => {
    if (!deleteUid) {
      return;
    }

    setIsLoading(true);
    const data: ProjectUserDeleteBody = {
      userId: deleteUid,
      projectId: props.projectUid,
    };
    const result = await destroy(apiPath(`/v1/project_users/-/delete`), {
      data,
    });
    if (!result.isSuccess) {
      setIsLoading(false);
      return;
    }
    props.onDeleted(props.users.filter((u) => u.uid !== deleteUid));
    setIsLoading(false);
    setDeleteUid(null);
  };

  const onCloseDeleteDialog = () => {
    setDeleteUid(null);
  };

  return {
    state: {
      isOpen,
      users: props.users,
      deleteUid,
      isLoading,
    },
    actions: {
      setIsOpen,
      onClose,
      setDeleteUid,
      onDelete,
      onCloseDeleteDialog,
    },
  };
}
